module.exports = __webpack_public_path__ + "media/domenj/home_beta-7172244f.png";